import { useIsSplitEnabled } from '@buffer-mono/features'

const COMPOSER_ZUSTAND_EDITOR_STATE_FLAG = 'composer-zustand-editor-state'

/**
 * Kill-switch for the editorState migration track (CORE-7187). Not nested
 * behind `composer-zustand-mode-state` — editorState has its own narrow
 * consumer set (editor plugins + `SlateJsProxy` callers) and no shared gate
 * to reuse. On: `editorSlice` is treated as canonical per the phase that's
 * shipped (see `~/notes/notes/claude/plans/composer/editor-state-migration.md`).
 * Off: Flux `ComposerStore.draft.editorState` remains the sole source of truth.
 */
export function useEditorStateEnabled(): boolean {
  return useIsSplitEnabled(COMPOSER_ZUSTAND_EDITOR_STATE_FLAG)
}
